module.exports = __webpack_public_path__ + "fonts/RenaultLife-Italic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Italic.svg
// module id = 358
// module chunks = 0